import Guest from "../components/guest/Guest";

function GuestPage() {
  return <Guest />;
}

export default GuestPage;
